import React from 'react';
import PaymentApp from '@components/App';
import { initializeAppData, hydrate } from './bootstrap';

const initialAppData = initializeAppData();
hydrate({ App: PaymentApp, initialAppData });
